import React from "react";

const Title = () => {
  return <h1 id="title">Pokémon Breeding Compatibility Checker</h1>;
};

export default Title;
